module.exports = __webpack_public_path__ + "img/themecolors.644801ad.png";